<!--返回、取消任务、接单-->
<template>
  <div style="text-align:center">
    <div class="btm-button" v-if="taskEdit.status == 1 && userInfo.identity !==3">
      <el-button size="medium" @click="back">返 回</el-button>
      <el-button @click="cancel">取 消 任 务</el-button>
      <el-button type="primary" @click="accept">接 单</el-button>
    </div>

    <div class="btm-button" v-if="taskEdit.status == 5">
      <el-button type="primary" @click="getTaskSignRegisterList">配送完成</el-button>
    </div>
    <sign-for :signForVisible.sync="signForVisible" :signForInfo="signForInfo" @closeDialog="closeDialog" :code="currentCode"></sign-for>
  </div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import { UPDATESTATUSS, GETTASKSIGNREGISTERLIST } from '@/store/assignmentManage/types'
import signFor from './signFor'
import user from '@/store/user/index'

export default {
  props: ['code', 'taskEdit', 'natures'],
  components: {signFor},
  data () {
    return {
      signForVisible: false,
      currentCode: null
    }
  },
  computed: {
    signForInfo () {
      return assignmentManage.state.signForList
    },
    userInfo () {
      return user.state.userinfo
    }
  },
  mounted () {

  },
  methods: {
    // 接单
    accept () {
      let params = {
        codes: this.code,
        status: 2
      }
      this.updateStatus(params)
    },
    // 取消任务
    cancel () {
      let params = {
        codes: this.code,
        status: 4
      }
      this.$confirm('您确定要取消当前任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateStatus(params)
      })
    },
    // 修改状态
    updateStatus (params) {
      let self = this
      let list = new Promise((resolve, reject) => {
        self.$store.dispatch(UPDATESTATUSS, params).then(res => {
          if (res.code === 200) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            })
            self.back()
          } else {
            this.$message({
              showClose: true,
              message: '任务状态已发生变更',
              type: 'error'
            })
            setTimeout(() => {
              assignmentManage.state.assigneditMark = 2
            }, 1000)
          }
        }).catch(error => {
          reject(error)
        })
      })
      console.log(list)
    },
    // 返回
    back () {
      assignmentManage.state.assigneditMark = 1
      // if (this.natures === '2') {
      //   return this.$router.push('/assignmentmanage/warehouseinto')
      // }
      // this.$router.push('/assignmentmanage/warehouseout')
    },
    // 打开配送完成窗口
    getTaskSignRegisterList () {
      this.currentCode = this.code
      this.$store.dispatch(GETTASKSIGNREGISTERLIST, {code: this.code})
      this.signForVisible = true
    },
    // 关闭窗口
    closeDialog (val) {
      this.signForVisible = false
      if (val) {
        setTimeout(() => {
          assignmentManage.state.assigneditMark = 2
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/components/orderReceiving.vue